/* Header and browser-chrome colour on the hero page.

   Previous versions cached references to .swing-rig and #header-component at init.
   If Horizon re-renders a section (view transitions, section rendering API), those
   references become detached from the document. getBoundingClientRect() on a detached
   element returns all zeros, so `bottom <= 2` was permanently true and the header stayed
   locked in its solid/white state with no way back. Everything below re-queries the DOM
   on every update and cross-checks against scroll position, so a stale node cannot latch
   the state on. */
(function () {
  // A second copy of this file used to run (it was loaded from both the layout and the
  // hero section). Each instance had its own MutationObserver on the theme-color tag, so
  // they overwrote each other's value forever, pinning the main thread and making the
  // page feel frozen and unresponsive. One instance only, from now on.
  if (window.__parformHeader) return;
  window.__parformHeader = true;

  var HERO = '#0E1512';   // matches the darkest part of the graded footage
  var PAGE = '#FFFFFF';
  var lastWanted = null;

  function meta() {
    var m = document.querySelector('meta[name="theme-color"]');
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'theme-color');
      document.head.appendChild(m);
    }
    return m;
  }

  function setChrome(dark) {
    var want = dark ? HERO : PAGE;
    lastWanted = want;
    var r = document.documentElement;
    r.classList.toggle('parform-chrome-dark', dark);
    r.classList.toggle('parform-chrome-light', !dark);
    var m = meta();
    if (m.getAttribute('content') !== want) m.setAttribute('content', want);
  }

  // Desktop Horizon scrolls .page-wrapper, not the window, so read from whichever
  // element is actually scrolling.
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw) {
      var oy = getComputedStyle(pw).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && pw.scrollHeight > pw.clientHeight + 1) return pw;
    }
    return null;
  }

  function scrollY() {
    var s = scroller();
    if (s) return s.scrollTop;
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function viewportH() {
    var s = scroller();
    return s ? s.clientHeight : window.innerHeight;
  }

  function update() {
    // re-query every time: never trust a cached node
    var hero = document.querySelector('.swing-rig');
    var hdr = document.getElementById('header-component');
    if (!hero) { setChrome(false); return; }
    if (hdr) hdr.removeAttribute('data-theme-color');

    // Base the decision on the STAGE, which is the thing actually covering the screen.
    // The rig stays tall for a while after the stage has unpinned and moved down, so
    // keying off the rig left the header in "over video" mode while light page content
    // was already sitting under it.
    var stage = hero.querySelector('.swing-stage');
    var target = stage || hero;
    var rect = target.getBoundingClientRect();
    var detached = rect.top === 0 && rect.bottom === 0 && rect.height === 0;
    var hdrH = (hdr && hdr.getBoundingClientRect().height) || 60;

    var solid;
    if (detached) {
      // fall back to raw scroll position rather than trusting a zeroed rect
      solid = scrollY() > viewportH();
    } else {
      // The header is transparent only while the stage is actually behind it. Once the
      // stage unpins and drops away, page content sits under the header, so it must go
      // solid immediately, not wait for the tall rig to finish scrolling past.
      var coversHeader = rect.top <= hdrH * 0.5 && rect.bottom >= hdrH;
      solid = !coversHeader;
    }
    // a hard floor: near the top of the document we are always over the video
    if (scrollY() < viewportH() * 0.5) solid = false;

    if (hdr) {
      hdr.classList.toggle('parform-header-solid', solid);
      hdr.classList.toggle('parform-header-clear', !solid);
    }
    setChrome(!solid);
  }

  function init() {
    if (!document.querySelector('.swing-rig')) { setChrome(false); return; }
    document.documentElement.classList.add('parform-hero-page');

    var ticking = false;
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    var sc = scroller();
    if (sc) sc.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('pageshow', update);
    window.addEventListener('load', update);

    // if anything else rewrites the meta, put ours back
    // Re-assert our colour if something else rewrites it, but with a hard cap so this
    // can never become a write loop. Anything beyond a handful of corrections in a
    // second means another script is fighting us, and losing quietly beats freezing.
    var m = meta();
    if (window.MutationObserver) {
      var writes = 0, windowStart = Date.now(), obs;
      obs = new MutationObserver(function () {
        if (!lastWanted || m.getAttribute('content') === lastWanted) return;
        var now = Date.now();
        if (now - windowStart > 1000) { writes = 0; windowStart = now; }
        if (++writes > 8) { obs.disconnect(); return; }
        m.setAttribute('content', lastWanted);
      });
      obs.observe(m, { attributes: true, attributeFilter: ['content'] });
    }

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
